<template>
    <el-container style="height: 100%" >
        <el-aside width="200px">
            <div class="main-title">人工批改</div>
            <el-menu
                    style="height: calc(100% - 60px)"
                    class="el-menu-vertical-demo"
                    background-color="#243046"
                    :default-active="defaultRouter"
                    text-color="#fff"
                    router
                    @select="getBreadcrumb"
                    active-text-color="#1890ff">
                <el-menu-item index="/receive-tasks" route="/receive-tasks">
                    <i class="el-icon-menu"></i>
                    <span slot="title">批改任务认领</span>
                </el-menu-item>
                <el-menu-item index="/papercorrection" route="/papercorrection/">
                    <i class="el-icon-s-marketing"></i>
                    <span slot="title">试卷批改</span>
                </el-menu-item>
              <el-submenu index="jk-task">
                <template slot="title">
                  <i class="el-icon-s-cooperation"></i>
                  <span>招警机考批改</span>
                </template>
                <el-menu-item index="/jk-task-distribute" route="/jk-task-distribute">批改任务分配</el-menu-item>
                <el-menu-item index="/my-correction-task" route="/my-correction-task">我的批改任务</el-menu-item>
              </el-submenu>
                <!-- <el-menu-item index="/homeworkcorrection" route="/homeworkcorrection">
                    <i class="el-icon-s-marketing"></i>
                    <span slot="title">作业批改</span>
                </el-menu-item> -->
            </el-menu>
        </el-aside>
        <el-container>
            <el-header style="background-color: #fff; border-bottom: 1px solid #eee;">
                <el-row type="flex" class="row-bg" justify="space-between" align="middle">
                    <el-col :span="8">
                      <el-breadcrumb separator="/">
                        <el-breadcrumb-item v-for="item in breadcrumb">{{item}}</el-breadcrumb-item>
                      </el-breadcrumb>
                    </el-col>
                    <el-col :span="4" :offset="12">
                        <!-- <span><span style="font-weight:700">{{ name }}</span>&nbsp;&nbsp;&nbsp;<span class="quit-system" @click="quitSystem()">退出</span></span> -->
                        <el-dropdown>
                          <span class="el-dropdown-link">
                            <span style="font-weight:700; font-size: 16px; cursor: pointer;">{{ name }}<i class="el-icon-arrow-down el-icon--right"></i></span>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="quitSystem()">
                                    退出登录
                                </span>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </el-header>
            <el-main class="main-content">
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
    // import global_ from '../../global/index.js'
    export default {
        name: "Index",
        data() {
            return {
                name : '',
                store_name:'',
                loading: true,
                is_show: false,
                sso_id: '',
                module_type: '',
                exer_id: '',
                breadcrumb: []
            }
        },
        computed: {
          defaultRouter() {
            if (this.$route.path.indexOf('/papercorrection') > -1) {
              return '/papercorrection';
            } else {
              return this.$route.path;
            }
          }
        },
        mounted(){
            this.name = window.localStorage.getItem('user_no')
            // this.store_name = window.localStorage.getItem('store_name')
            // this.getRole();
          this.getBreadcrumb(this.defaultRouter)
        },
        methods:{
          getRole(id){
                this.$api.USERLOGINROLE({}).then((res) => {
                    if(res.retcode==0){

                        this.is_show = res.data[0].role_type == 3? false : true;
                    }else{
                        this.$message.error(res.message);
                    }

                })
            },
          getBreadcrumb (val) {
            switch(val) {
              case '/receive-tasks':  this.breadcrumb = ['批改任务认领']; break;
              case '/papercorrection': this.breadcrumb = ['试卷批改']; break;
              case '/jk-task-distribute':
                this.breadcrumb = ['招警机考批改', '批改任务分配']
                break;
              case '/my-correction-task':
                this.breadcrumb = ['招警机考批改', '我的批改任务']
                break;
            }
          }
        }
    }
</script>

<style scoped>
    .main-title {
        width: 200px;
        font-size: 16px;
        color: #fff;
        height: 60px;
        line-height: 60px;
        background-color: rgb(27,42,54);
        font-weight: 700;
        text-align: center;
    }
    .system-name {
        font-size: 20px;
        font-weight: bold;
        margin-left: 5px;
        cursor: pointer
    }
    .main-content{
        padding: 20px;
        height: 100%;
    }
    .el-menu{
        border-right: none;
    }
    .row-bg {
        height: 100%;
        text-align: center;
    }
</style>
<style type="text/css">
    .quit-system{
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue